import { status } from 'skin/event/status'

export default function click(obj, ms, story, data, d, action) {
	const key = story.s.tnk_valve.table?.sectionRow?.row
	if (obj.key === key) return status.ignore
	return status.action
}
